import { NumberInput } from '@mantine/core';
import classNames from 'theme/components/Inputs/NumberInput/NumberInput.module.css';

export default NumberInput.extend({
  classNames,
  defaultProps: {
    size: 'md',
  },
});
